import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ForChildSwitch } from '../../../../components/ForChildSwitch/ForChildSwitch';
import { AgeSelector } from '../../../../components/AgeSelector/AgeSelector';
import './ChildServiceSelector.scss';
import { setBookingError } from '../../../store/serviceSlice';

const styles = require('b_')
    .with('child-service-selector');

export const ChildServiceSelector = ({
    forChild,
    childrenAge,
    onSelect,
}) => {
    const [ forChildValue, setForChildValue ] = useState(forChild);
    const [ childrenAgeValue, setChildrenAgeValue ] = useState(childrenAge);
    const dispatch = useDispatch();

    useEffect(() => {
        setForChildValue(forChild);
        setChildrenAgeValue(childrenAge);
    }, [ forChild, childrenAge ]);

    useEffect(() => {
        // dispatch(setBookingError('')); caused EPMAIMD-49306
        onSelect && onSelect(!!forChildValue, childrenAgeValue ?? 0);
    }, [ forChildValue, childrenAgeValue ]);
    return <>
        <div className={styles('age')}>
            <div className={styles('age-item')}>
                <ForChildSwitch value={forChildValue} onChange={setForChildValue}/>
            </div>
            <div className={styles('age-item')}>
                {!!forChildValue && (
                    <AgeSelector
                        onChange={setChildrenAgeValue}
                        label="полных лет"
                        age={childrenAgeValue}
                    />
                )}
            </div>
        </div>
    </>;
};
